<script setup>
import { computed, ref, watch } from 'vue'
import md5 from 'js-md5'

const props = defineProps({ user: { type: Object, required: true } })
const failed = ref(false)
const email = computed(() => (props.user.email || '').trim().toLowerCase())
watch(email, () => { failed.value = false })
const fallback = computed(() => {
  const username = (props.user.username || '').trim()
  const letter = (Array.from(username)[0] || '?').toUpperCase()
    .replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;' })[char])
  const colors = ['#3751a0', '#176b64', '#854080', '#9b4426', '#586524', '#6550a2']
  let hash = 0
  for (const char of username.toLowerCase()) hash = (hash * 31 + char.codePointAt(0)) >>> 0
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"><rect width="80" height="80" rx="40" fill="${colors[hash % colors.length]}"/><text x="40" y="41" dy=".35em" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-size="38" font-weight="600">${letter}</text></svg>`
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
})
const source = computed(() => email.value && !failed.value
  ? 'https://www.gravatar.com/avatar/' + md5(email.value) + '?d=404&s=80'
  : fallback.value)
</script>

<template>
  <img class="avatar" :src="source" alt="" @error="failed = true" />
</template>
